import { Form } from 'react-bootstrap';
import { TimeSelector } from '../TimeSelector/TimeSelector';
import { EmailInput } from '../EmailInput/EmailInput';
import { PhoneInput } from '../PhoneInput/PhoneInput';
import Select from 'react-select';
import InputContainer from '../PantallasEdit/InputContainer/InputContainer';
import { FormHelper, StyleHelper } from '../../Utils';

export function ControlledInput ({
                                    type = "text",
                                    label = "",
                                    placeholder = "",
                                    onChange,
                                    required = false,
                                    setState = () => {},
                                    name = "text",
                                    value = "",
                                    disabled = false,
                                    options = [],
                                    isClearable = false,
                                    hideType: hidePhoneType = false,
                                    propsContainer = {},
                                    min = 0
                                }){
    const requiredInputStyle = required ? { borderLeft: "3px solid red" } : {};
    const requiredSelectStyle = {
        control: (baseStyles, state) => ({
            ...baseStyles,
            ...(required ? StyleHelper.InputRequired : {}),
        }),
    };

    const renderInput = () => {
        switch (type.toLowerCase()) {
            case "color":
                return (
                    <Form.Control
                        disabled={disabled}
                        onChange={(e) => FormHelper.handleChange(e, setState)}
                        name={name}
                        type="color"
                        value={value ?? "#000000"}
                    />
                );
            case "timeselector":
                return (
                    <TimeSelector
                        isDisabled={disabled}
                        onChange={(e) => {
                            setState((prev) => ({ ...prev, [name]: e?.TotalMinutos }));
                        }}
                        initialValue={value || 0}
                    />
                );
            case "select":
                return (
                    <Select
                        placeholder={placeholder}
                        isDisabled={disabled}
                        className="basic-single"
                        classNamePrefix="select"
                        name={name}
                        isClearable={isClearable}
                        onChange={(e) => {
                            onChange
                                ? onChange(e)
                                : setState((prev) => ({
                                    ...prev,
                                    [name]: e.value,
                                }));
                        }}
                        options={options || []}
                        value={options.filter(function (option) {
                            return option.value === value;
                        })}
                        styles={requiredSelectStyle}
                    />
                );
            case "phone":
                return (
                    <PhoneInput
                        required={required}
                        initialValue={value}
                        hideType={hidePhoneType}
                        onChange={(tels) =>
                            setState((prev) => ({
                                ...prev,
                                [name]: tels,
                            }))
                        }
                    />
                );
            case "email":
                return (
                    <EmailInput
                        required={required}
                        inputValue={value}
                        placeholder={placeholder || "Correo Electrónico"}
                        parentCallback={onChange}
                    />
                );
            case "password":
                return (
                    <Form.Control
                        placeholder={placeholder}
                        disabled={disabled}
                        onChange={(e) => FormHelper.handleChange(e, setState)}
                        name={name}
                        type="password"
                        value={value || ""}
                        style={requiredInputStyle}
                    />
                );
            case "number":
                return (
                    <Form.Control
                        placeholder={placeholder}
                        disabled={disabled}
                        onChange={(e) => FormHelper.handleChange(e, setState)}
                        name={name}
                        type="number"
                        value={value || ""}
                        style={requiredInputStyle}
                        min={min}
                    />
                );
            case "text":
                return (
                    <Form.Control
                        placeholder={placeholder}
                        disabled={disabled}
                        onChange={(e) => FormHelper.handleChange(e, setState)}
                        name={name}
                        type="text"
                        value={value || ""}
                        style={requiredInputStyle}
                    />
                );
        }
    };

    return (
            <InputContainer label={label} {...propsContainer}>
                {renderInput()}
            </InputContainer>
    );
}
